const dictionary: any = {
    // Common
    'user': 'User',
    'building': 'Building',
    'note': 'Notes',
    'rentedOut': 'Rented Out',
    'suite': 'Unit',
    'suite_user': 'Suite User',
    'name': 'Name',
    'occupancyDate': 'Occupancy Date',
    'fieldValue': 'Field Value',

    // Unit
    'suiteNumber': 'Unit Number',
    'emergencyContact': 'Emergency Contact',
    'proportionateShare': 'Prop. Share %',
    'buzz': 'Buzz',
    'keyCode': 'Key Code',
    'keyFob': 'Key Fob',
    'key_code': 'Key Code',
    'key_fob': 'Key Fob',
    'powerAttorney': 'Power Attorney',
    'legalDescription': 'Legal Description',
    'allowedVisitor': 'Allowed Visitors',
    'level': 'Level',
    'subName': 'Sub Name',
    'enterPhone': 'Enter Phone',
    'fromFiveReceived': 'Form Five Received',
    'emergency_contact': 'Emergency Contact',
    'isPrimary': 'Primary',
    'relation': 'Relation',
    'permissionToEnter': 'Permission To Enter',
    'signature': 'Signature',
    'oauthId': 'Oauth Id',
    'disabilities': 'Disabilities',
    'primaryAddress': 'Primary Address',
    'archived': 'Archived',
    'owner': 'Owner',

    // Resident
    'isPrimaryAddress': 'Primary Address',
    'isPrimaryPhone': 'Primary Phone',
    'role': 'Occupant Type',
    'rent': 'Tenant',
    'owner_off': 'Owner Off-Site',
    'resident_owner': 'Resident Owner',
    'resident_only_not_on_deed': 'Resident Only Not On Deed',
    'owner_family': 'Owner Family',
    'guest': 'Guest',
    'offsite_resident': 'Offsite Resident',
    'staff_only': 'Staff Only',
    'occupant': 'Occupant',
    'owner_on': 'Owner On-Site',
    'unknown': 'Not set',
    'fullName': 'Full Name',
    'email': 'Email',
    'address': 'Address',
    'emailWaiverSigned': 'Email Waiver Signed',
    'parcelWaiverSigned': 'Parcel Waiver Signed',
    'keyWaiverSigned': 'Key Waiver Signed',
    'isValidEmail' : 'Is Email Valid',
    'moveOutDate' : 'Move Out Date',
    'ownerInformationFormReceived' : 'Owner Information Form Received',
    'leaseReceived' : 'Lease Received',
    'tenantInformationFormReceived' : 'Information Form Received',
    'primaryLeaseHolder' : 'Primary Lease Holder',
    'leaseStartDate' : 'Lease Start Date',
    'maxTvUser' : 'Active',
    'residentStatus' : 'Active',
    'userType' : 'User Type',
    'resident_instruction': 'Resident Instruction',
    'type' : 'Type',
    'text' : 'Text',
    'entry_instruction' : 'Entry Instruction',
    'vacation_instruction' : 'Vacation Instruction',

    'phone': 'Phone',
    'phoneType': 'Phone Type',
    'phone_home': 'Home',
    'phone_cell': 'Cell',
    'phone_business': 'Phone Business',
    'phone_fax': 'Fax',
    'phone_business_fax': 'Business Fax',
    'phone_other': 'Other',

    'city': 'City',
    'dateOfBirth': 'DOB',
    'countryName': 'Country',
    'state': 'Province / State',
    'postalCode': 'Postal Code',
    'emergencyAssistantNotes': 'Emergency Notes',
    'consent': 'Consent',

    // Parking spot
    'parkingNumber': 'Parking Spot',
    'rentedTo': 'Rented To',
    'garageRemote': 'Garage Remote',
    'handicap': 'Handicap',

    // Lockers
    'lockerKeyCode': 'Locker Number',

    // Vehicle
    'licensePlate': 'License Plate #',
    'year': 'Year',
    'color': 'Color',
    'model': 'Model',
    'brand': 'Make',
    'ownerName': 'Owner Name',
    'permitNumber': 'Permit Number',

    // Pet
    'weight': 'Weight',
    'height': 'Height',
    'breed': 'Breed',
    'petType': 'Pet Type',

    // Rack number
    'rackNumber': 'Rack #',
    'bike_rack': 'Bike Rack',
    'locker': 'Locker',
    'parking': 'Parking',
    'pet': 'Pet',
    'resident': 'Resident',
    'resident_address': 'Resident Address',
    'resident_alternative_email': 'Resident Alternative Email',
    'resident_phone': 'Resident Phone',
    'vehicle': 'Vehicle',

    // Parcels
    'parcels': 'Parcel',
    'parcelNumber': 'Parcel Number',
    'barCode': 'Bar Code',
    'numberPieces': 'Number Of Pieces',
    'description': 'Description',
    'status': 'Status',
    'inOut': 'In/Out',
    'createdAt': 'Created At',
    'emailNotice': 'Email Notice',
    'parcelPostService': 'Courier',
    'parcelTypeName': 'Parcel Type Name',
    'parcelPostServiceName': 'Other Courier',
    'returningBy': 'Returning By',
    'pickedUpByPostService': 'Picked Up By Post Service',
    'cancelledBy': 'Cancelled By',
    'reminderSentAt': 'Reminder Sent At',

    // Service Request
    'serviceRequest':                 'Service Request',
    'createdBy':                      'Created by',
    'serviceRequestComment':          'Service Request Comment',
    // 'serviceRequestWorkerContract':   'Service Request Worker',
    // 'serviceRequestWorkerContractOther':   'Service Request Worker Other',
    // 'serviceRequestType':             'Service Request Type',
    'requestTypeLoggable':            'Service Request Type',
    'requestWorkerLoggable':          'Service Request Worker',
    'serviceRequestNumber':           'Service Request Number',
    // 'serviceRequestTypeOther':        'Other Service Request Type',
    'isRead':                         'Is Read',
    'priority':                       'Priority',
    'shareContact':                   'Share Contact',
    'notes':                          'Notes',
    'isPrivate':                      'Is Private',

    'pickedUpBy': 'Picked Up By',
    'parcelType': 'Parcel Type',
    'receivedBy': 'Received By',
    'InOut': 'Direction',
    'CreatedAt': 'Created At',
    'updatedAt': 'Updated At',
    'EmailNotice': 'Email Notice',

    // Documents
    'owner_all': 'Owner All',
    'not_set': 'Not Set',
    'all': 'All',

    // Pass On Log
    'passOnLogNumber' : 'Pass On Log Number',
    'subject' : 'Subject',
    'announcement' : 'Announcement',
    'startDate': 'Start Date',
    'endDate' : 'End Date',

    // Users
    'invite': 'Invite',
    'resetPassword': 'Reset Password',
    'isActive': 'Active',
    'isInvited': 'Invited',
    'aboutMe': 'About Me',
    'lastLogin': 'Last Login',

    // Key Log
    'keyTag': 'Key Tag',
    'purpose': 'Purpose',
    'activityNotes': 'Activity Notes',

    'user_groups': 'User Group',

    //Incident Report
    'incidentReportNumber': 'Incident Report Number',
    'incidentReport': 'Incident Report',
    'incidentReportType': 'Incident Report Type',
    'incidentReportTypeOther': 'Incident Report TypeOther',
    'reportedArea': 'Reported Area',
    'reportedBy': 'Reported By',
    'incident': 'Incident',
    'pathToPdf': 'Path To PDF',
    'pdfName': 'PDF Name',
    'incidentAt': 'Happened At',
};

export class ActivityDictionary {
    static getValue(key: string): string {
        return dictionary[key] || key;
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/directory-item/activity/activity.dictionary.ts